import { SignatureConfigurationNode } from "entities/ApiModel/SignatureConfigurationNode";

export type DuplicateAgency = {
  agencyName: string;
  id: string;
};

export function getSelectedAgencyNames(root: any): string[] {
  const selectedAgencies: string[] = [];

  for (const agency of root.Children) {
    const stack: SignatureConfigurationNode[] = [...agency.Children];
    let isSelected = false;

    while (stack.length && !isSelected) {
      const node = stack.pop()!;

      if (node.Selected) {
        isSelected = true;
        selectedAgencies.push(agency.Name);
        break;
      }

      if (node.Children?.length) {
        stack.push(...node.Children);
      }
    }
  }

  return selectedAgencies;
}


export function getDuplicateAgencies(root: SignatureConfigurationNode): DuplicateAgency[] {
  const result: DuplicateAgency[] = [];
  const stack: SignatureConfigurationNode[] = [root];

  while (stack.length) {
    const node = stack.pop()!;

    if (node.IsDuplicatedSignature) {
      result.push({
        agencyName: node.Name,
        id: node.ID,
      });
      // Skip traversing children once duplication is confirmed
      continue;
    }

    if (node.Children?.length) {
      stack.push(...node.Children);
    }
  }

  return result;
}